import React, { Component, useState, useRef, useEffect } from 'react';
import { Box,
    Flex,
    HStack, 
    Stack, 
    Checkbox, 
    Input, 
    Text, 
    Textarea,
    Select,
    Divider,
    InputGroup,
    Img,
    Image,
    Button,
    useToast,
    Spacer,
    FormHelperText,
    FormLabel,
    FormControl } from '@chakra-ui/react';
import Fade from "react-reveal";
import MinimalistKit from './MinimalistKit';
import * as htmlToImage from 'html-to-image';

const renderImage = (file) => {
    if(file){
        return ( <Image src={file} boxSize={'20'} objectFit={'contain'} />);
    }
    return;
}

export default function MediaKitTool(props) {
    const redtheme = props.redtheme;
    const toast = useToast();

    const handleDownloadJpg = async () => {
        htmlToImage.toJpeg(document.getElementById('printReference'), { quality: 0.95 })
            .then(function (dataUrl) {
        var link = document.createElement('a');
        link.download = 'media-kit.jpeg';
        link.href = dataUrl;
        link.click();
        });
      };

    const [generate, setGenerate] = useState(false);
    const handleKitGenerate = (e) => {
        if(!name || !subheader || !bio || !profile || !file1 || !file2
            || followers.platform1 == '' || followers.followers1 == ''
            || followers.platform2 == '' || followers.followers2 == ''
            || stats.stat1 == '' || stats. stat2 == '' || stats.stat3 == ''
            || stats.metric1 == '' || stats.metric12 == '' || stats.metric3 == ''
            || audience.gender == '' || audience.genderStat == '' 
            || audience.ageRange == '' || audience.ageRangeStat == ''
            || audience.country == '' || audience.countryStat == ''
            || services.service1 == '' || services.service2 == ''
            || services.service3 == '' || contact.contact1 == ''
            || contact.contact2 == '' || contact.handle1 == ''
            || contact.handle2 == '' || (includeRates && (rates.rate1 == ''
            || rates.rate2 == '' || rates.rate3 ==''))){
            toast({
                title: 'Please fill out all required elements',
                status: 'error',
                isClosable: true,
            });
        }
        else{
            setGenerate(true);
        }
    };

    const [name, setName] = useState();
    const [subheader, setSubheader] = useState();
    const [bio, setBio] = useState();
    const [followers, setFollowers] = useState({
        platform1: '',
        followers1: '',
        platform2: '',
        followers2: '',
        platform3: '',
        followers3: ''
    });
    const handleFollowers = event => {
        const { name, value } = event.target;
        setFollowers({ ...followers, [name]: value });
    };

    const [stats, setStats] = useState({
        stat1: 'Avg IG Reach',
        metric1: '',
        stat2: 'Avg IG Engagement',
        metric2: '',
        stat3: 'Avg TikTok Views',
        metric3: ''
    });
    const handleStats = event => {
        const { name, value } = event.target;
        setStats({ ...stats, [name]: value });
    };

    const [audience, setAudience] = useState({
        gender: '',
        genderStat: '',
        ageRange: '',
        ageRangeStat: '',
        country: 'United States',
        countryStat: ''
    });
    const handleAudience = event => {
        const { name, value } = event.target;
        setAudience({ ...audience, [name]: value });
    };

    const [services, setServices] = useState({
        service1: 'Instagram Feed Post',
        service2: 'Instagram Reel',
        service3: 'Contest/Giveaway',
        service4: '',
        service5: ''
    });
    const handleServices = event => {
        const { name, value } = event.target;
        setServices({ ...services, [name]: value });
    };

    const [includeRates, setIncludeRates] = useState(false);
    const onChangeChecked = (e) => {
        setIncludeRates(e.target.checked);
      };

    const [rates, setRates] = useState({
        rate1: '',
        rate2: '',
        rate3: '',
        rate4: '',
        rate5: ''
    });
    const handleRates = event => {
        const { name, value } = event.target;
        setRates({ ...rates, [name]: value });
    };

    const [contact, setContact] = useState({
        contact1: '',
        handle1: '',
        contact2: '',
        handle2: '',
        contact3: '',
        handle3: '',
    });
    const handleContact = event => {
        const { name, value } = event.target;
        setContact({ ...contact, [name]: value });
    };

      const inputRefProfile = useRef();
      const [profile, setProfile] = useState();
      const handleProfileWrapperClick = () => {
        inputRefProfile.current?.click()
      }
      const handleProfile = (e) => {
          console.log(e.target.files);
          setProfile(URL.createObjectURL(e.target.files[0]));
      }

      const inputRefFile1 = useRef();
      const [file1, setFile1] = useState();
      const handleFile1WrapperClick = () => {
        inputRefFile1.current?.click()
      }
      const handleFile1 = (e) => {
          console.log(e.target.files);
          setFile1(URL.createObjectURL(e.target.files[0]));
      }

      const inputRefFile2 = useRef();
      const [file2, setFile2] = useState();
      const handleFile2WrapperClick = () => {
        inputRefFile2.current?.click()
      }
      const handleFile2 = (e) => {
          console.log(e.target.files);
          setFile2(URL.createObjectURL(e.target.files[0]));
      }
        
    return (
            <Box 
                boxShadow={'xl'}
                p={7}
                rounded={'md'}
                bg={'redyel.300'}
                minWidth={{base: 'max-content', sm: 'max-content', md: 'max-content', lg: '80vw'}}>

                <Stack spacing={'3'}>

{/*Start of Bio Section*/}
                    <HStack spacing={'3'}>
                        <FormControl>
                            <FormLabel 
                                fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                color={'redyel.900'}>
                            Name *
                            </FormLabel>
                            <Input 
                                size='sm'
                                focusBorderColor={'redyel.600'}
                                borderColor={'redyel.400'}
                                color={'redyel.900'}
                                _hover={{
                                    borderColor: 'redyel.500',
                                }}
                                borderRadius={'4'}
                                value={name} 
                                onChange={event => setName(event.target.value)}/>
                        </FormControl>

                        <FormControl>
                            <FormLabel
                                fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                color={'redyel.900'}>
                            Subheader *
                            </FormLabel>
                            <Input placeholder='ex. Fashion | Beauty | Lifestyle' 
                                size='sm'
                                focusBorderColor={'redyel.600'}
                                borderColor={'redyel.400'}
                                color={'redyel.900'}
                                _hover={{
                                    borderColor: 'redyel.500',
                                }}
                                borderRadius={'4'}
                                _placeholder={{ opacity: 0.3, color: 'redyel.800' }}
                                value={subheader} 
                                onChange={event => setSubheader(event.target.value)}/>
                        </FormControl>
                    </HStack>
                    <HStack spacing={'3'}>
                        <FormControl>
                            <FormLabel
                                fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                color={'redyel.900'}>
                            Bio/About *
                            </FormLabel>
                            <Textarea 
                                size='sm'
                                focusBorderColor={'redyel.600'}
                                borderColor={'redyel.400'}
                                color={'redyel.900'}
                                _placeholder={{ opacity: 0.3, color: 'redyel.800' }}
                                _hover={{
                                    borderColor: 'redyel.500',
                                }}
                                borderRadius={'4'}
                                placeholder="It's generally a good idea to provide ~3 sentences about what kind of content you make and what excites you. For this template, you should aim for somewhere between 400-500 characters."
                                value={bio}
                                onChange={event => setBio(event.target.value)}/>
                            <FormHelperText
                                color={'redyel.600'}
                                textAlign={'right'}
                                >Character count: {bio ? bio.toString().length : 0}</FormHelperText>
                        </FormControl>
                        <FormControl alignContent={'flex-start'}>
                            <FormLabel 
                                fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                color={'redyel.900'}>
                            Profile Photo *
                            </FormLabel>
                            <FormHelperText
                                color={'redyel.600'}
                                textAlign={'left'}
                                fontSize={'xs'}
                                mb={3}
                                mt={-2}
                                >Max Size: 5MB <br/> Types: JPG, PNG</FormHelperText>
                            <HStack>
                                <InputGroup onClick={handleProfileWrapperClick}>
                                    <input type="file" onChange={handleProfile} ref={inputRefProfile} style={{ display: 'none' }}/>
                                    <Button 
                                        isLoading={false} 
                                        bgColor={'redyel.400'} 
                                        color={'redyel.700'}
                                        _hover={{
                                            bg: 'redyel.500',
                                        }}>
                                        Choose Profile Photo
                                    </Button>
                                </InputGroup>
                                {renderImage(profile)}
                            </HStack>
                        </FormControl>
                    </HStack>

                    <HStack spacing={'3'} maxW={'50%'}>
                        <FormControl>
                            <FormLabel 
                                fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                color={'redyel.900'}>
                            2 Accent Photos *
                            </FormLabel>
                            <FormHelperText
                                color={'redyel.600'}
                                textAlign={'left'}
                                fontSize={'xs'}
                                mb={3}
                                mt={-2}
                                >Max Size: 5MB <br/> Types: JPG, PNG</FormHelperText>
                            <HStack>
                                <InputGroup onClick={handleFile1WrapperClick}>
                                    <input type="file" onChange={handleFile1} ref={inputRefFile1} style={{ display: 'none' }}/>
                                    <Button 
                                        isLoading={false} 
                                        bgColor={'redyel.400'} 
                                        color={'redyel.700'}
                                        _hover={{
                                            bg: 'redyel.500',
                                        }}>
                                        Choose File 1
                                    </Button>
                                </InputGroup>
                                <InputGroup onClick={handleFile2WrapperClick}>
                                    <input type="file" onChange={handleFile2} ref={inputRefFile2} style={{ display: 'none' }}/>
                                    <Button 
                                        isLoading={false} 
                                        bgColor={'redyel.400'} 
                                        color={'redyel.700'}
                                        _hover={{
                                            bg: 'redyel.500',
                                        }}>
                                        Choose File 2
                                    </Button>
                                </InputGroup>
                                {renderImage(file1)}
                                {renderImage(file2)}
                            </HStack>
                        </FormControl>
                    </HStack>
                    <Spacer />
                    <Divider borderColor={'redyel.400'}/>
                    <Spacer />

{/*Start of Follower Count Section*/}
                    <HStack spacing={'3'} >
                        <Text 
                            fontSize={{ base: 'md', sm: 'md', md: 'lg' }}
                            as='b'
                            color={'redyel.700'}
                            fontFamily={'heading'}
                            >
                        Follower Counts -- 2-3 platforms
                        </Text>
                    </HStack>
                    <HStack spacing={'3'}>
                        <FormControl>
                            <FormLabel 
                                fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                color={'redyel.900'}>
                            Platform *
                            </FormLabel>
                            <Select placeholder='Select option' 
                            size='sm'
                            focusBorderColor={'redyel.600'}
                            borderColor={'redyel.400'}
                            color={'redyel.900'}
                            _placeholder={{ opacity: 0.3, color: 'redyel.800' }}
                            _hover={{
                                borderColor: 'redyel.500',
                            }}
                            borderRadius={'4'}
                            value={followers.platform1} 
                            onChange={handleFollowers}
                            name={'platform1'}>
                                <option value='Tiktok'>TikTok</option>
                                <option value='Instagram'>Instagram</option>
                                <option value='Youtube'>YouTube</option>
                                <option value='Twitch'>Twitch</option>
                                <option value='Twitter'>Twitter</option>
                            </Select>
                        </FormControl>
                        <FormControl>
                            <FormLabel 
                                fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                color={'redyel.900'}
                                >
                            Followers *
                            </FormLabel>
                            <Input placeholder='round up to nearest 100' 
                            focusBorderColor={'redyel.600'}
                            borderColor={'redyel.400'}
                            color={'redyel.900'}
                            _placeholder={{ opacity: 0.3, color: 'redyel.800' }}
                            _hover={{
                                borderColor: 'redyel.500',
                            }}
                            borderRadius={'4'}
                            size='sm' 
                            value={followers.followers1} 
                            onChange={handleFollowers}
                            name={'followers1'}/>
                        </FormControl>
                    </HStack>
                    <HStack spacing={'3'}>
                        <FormControl>
                            <FormLabel 
                                fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                minW={'10vw'}
                                color={'redyel.900'}>
                            Platform *
                            </FormLabel>
                            <Select placeholder='Select option' 
                            size='sm'
                            focusBorderColor={'redyel.600'}
                            borderColor={'redyel.400'}
                            color={'redyel.900'}
                            _placeholder={{ opacity: 0.3, color: 'redyel.800' }}
                            _hover={{
                                borderColor: 'redyel.500',
                            }}
                            borderRadius={'4'}
                            value={followers.platform2} 
                            onChange={handleFollowers}
                            name={'platform2'}>
                                <option value='Tiktok'>TikTok</option>
                                <option value='Instagram'>Instagram</option>
                                <option value='Youtube'>YouTube</option>
                                <option value='Twitch'>Twitch</option>
                                <option value='Twitter'>Twitter</option>
                            </Select>
                        </FormControl>
                        <FormControl>
                            <FormLabel 
                                fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                minW={'10vw'}
                                color={'redyel.900'}>
                            Followers *
                            </FormLabel>
                            <Input placeholder='round up to nearest 100' 
                            focusBorderColor={'redyel.600'}
                            borderColor={'redyel.400'}
                            color={'redyel.900'}
                            _placeholder={{ opacity: 0.3, color: 'redyel.800' }}
                            _hover={{
                                borderColor: 'redyel.500',
                            }}
                            borderRadius={'4'}
                            size='sm' 
                            value={followers.followers2} 
                            onChange={handleFollowers}
                            name={'followers2'}/>
                        </FormControl>
                    </HStack>
                    <HStack spacing={'3'}>
                        <FormControl>
                            <FormLabel 
                                fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                minW={'10vw'}
                                color={'redyel.900'}>
                            Platform
                            </FormLabel>
                            <Select placeholder='Select option' 
                            size='sm'
                            focusBorderColor={'redyel.600'}
                            borderColor={'redyel.400'}
                            color={'redyel.900'}
                            _placeholder={{ opacity: 0.3, color: 'redyel.800' }}
                            _hover={{
                                borderColor: 'redyel.500',
                            }}
                            borderRadius={'4'}
                            value={followers.platform3} 
                            onChange={handleFollowers}
                            name={'platform3'}>
                                <option value='Tiktok'>TikTok</option>
                                <option value='Instagram'>Instagram</option>
                                <option value='Youtube'>YouTube</option>
                                <option value='Twitch'>Twitch</option>
                                <option value='Twitter'>Twitter</option>
                            </Select>
                        </FormControl>
                        <FormControl>
                            <FormLabel 
                                fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                minW={'10vw'}
                                color={'redyel.900'}>
                            Followers
                            </FormLabel>
                            <Input placeholder='round up to nearest 100' 
                            focusBorderColor={'redyel.600'}
                            borderColor={'redyel.400'}
                            color={'redyel.900'}
                            _placeholder={{ opacity: 0.3, color: 'redyel.800' }}
                            _hover={{
                                borderColor: 'redyel.500',
                            }}
                            borderRadius={'4'}
                            size='sm'  
                            value={followers.followers3} 
                            onChange={handleFollowers}
                            name={'followers3'}/>
                        </FormControl>
                    </HStack>

                    <Spacer />
                    <Divider borderColor={'redyel.400'}/>
                    <Spacer />

{/*Start of Stats Section*/}
                    <HStack spacing={'3'}>
                        <Text
                            fontSize={{ base: 'md', sm: 'md', md: 'lg' }}
                            as='b'
                            color={'redyel.700'}
                            fontFamily={'heading'}>
                        Statistics
                        </Text>
                    </HStack>
                    <HStack spacing={'3'}>
                        <FormControl>
                            <FormLabel 
                                fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                minW={'10vw'}
                                color={'redyel.900'}>
                            Description *
                            </FormLabel>
                            <Input 
                            focusBorderColor={'redyel.600'}
                            borderColor={'redyel.400'}
                            color={'redyel.900'}
                            _placeholder={{ opacity: 0.3, color: 'redyel.800' }}
                            _hover={{
                                borderColor: 'redyel.500',
                            }}
                            borderRadius={'4'}
                            size='sm' 
                            value={stats.stat1} 
                            onChange={handleStats} 
                            name={'stat1'}/>
                        </FormControl>
                        <FormControl>
                            <FormLabel 
                                fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                minW={'10vw'}
                                color={'redyel.900'}>
                            Metric *
                            </FormLabel>
                            <Input placeholder='ex. 500K' 
                            focusBorderColor={'redyel.600'}
                            borderColor={'redyel.400'}
                            color={'redyel.900'}
                            _placeholder={{ opacity: 0.3, color: 'redyel.800' }}
                            _hover={{
                                borderColor: 'redyel.500',
                            }}
                            borderRadius={'4'}
                            size='sm'  
                            onChange={handleStats} 
                            name={'metric1'} 
                            value={stats.metric1}/>
                        </FormControl>
                    </HStack>
                    <HStack spacing={'3'}>
                        <FormControl>
                            <FormLabel 
                                fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                minW={'10vw'}
                                color={'redyel.900'}>
                            Description *
                            </FormLabel>
                            <Input 
                            focusBorderColor={'redyel.600'}
                            borderColor={'redyel.400'}
                            color={'redyel.900'}
                            _placeholder={{ opacity: 0.3, color: 'redyel.800' }}
                            _hover={{
                                borderColor: 'redyel.500',
                            }}
                            borderRadius={'4'}
                            size='sm' 
                            value={stats.stat2} 
                            onChange={handleStats} 
                            name={'stat2'}/>
                        </FormControl>
                        <FormControl>
                            <FormLabel 
                                fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                minW={'10vw'}
                                color={'redyel.900'}>
                            Metric *
                            </FormLabel>
                            <Input placeholder='ex. 10%' 
                            focusBorderColor={'redyel.600'}
                            borderColor={'redyel.400'}
                            color={'redyel.900'}
                            _placeholder={{ opacity: 0.3, color: 'redyel.800' }}
                            _hover={{
                                borderColor: 'redyel.500',
                            }}
                            borderRadius={'4'}
                            size='sm' 
                            onChange={handleStats} 
                            name={'metric2'} 
                            value={stats.metric2}/>
                        </FormControl>
                    </HStack>
                    <HStack spacing={'3'}>
                        <FormControl>
                            <FormLabel 
                                fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                minW={'10vw'}
                                color={'redyel.900'}>
                            Description *
                            </FormLabel>
                            <Input 
                            focusBorderColor={'redyel.600'}
                            borderColor={'redyel.400'}
                            color={'redyel.900'}
                            _placeholder={{ opacity: 0.3, color: 'redyel.800' }}
                            _hover={{
                                borderColor: 'redyel.500',
                            }}
                            borderRadius={'4'}
                            size='sm' 
                            value={stats.stat3} 
                            onChange={handleStats} 
                            name={'stat3'} />
                        </FormControl>
                        <FormControl>
                            <FormLabel 
                                fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                minW={'10vw'}
                                color={'redyel.900'}>
                            Metric *
                            </FormLabel>
                            <Input 
                            placeholder='ex. 400K' 
                            focusBorderColor={'redyel.600'}
                            borderColor={'redyel.400'}
                            color={'redyel.900'}
                            _placeholder={{ opacity: 0.3, color: 'redyel.800' }}
                            _hover={{
                                borderColor: 'redyel.500',
                            }}
                            borderRadius={'4'}
                            size='sm' 
                            onChange={handleStats} 
                            name={'metric3'} 
                            value={stats.metric3}/>
                        </FormControl>
                    </HStack>

                    <Spacer />
                    <Divider borderColor={'redyel.400'}/>
                    <Spacer />
{/*Start of Audience Metrics Section*/}
                    <HStack spacing={'3'}>
                        <Text 
                            fontSize={{ base: 'md', sm: 'md', md: 'lg' }}
                            as='b'
                            color={'redyel.700'}
                            fontFamily={'heading'}>
                        Audience Metrics
                        </Text>
                    </HStack>
                    <HStack spacing={'3'}>
                        <FormControl>
                            <FormLabel 
                                fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                minW={'10vw'}
                                color={'redyel.900'}>
                            Gender *
                            </FormLabel>
                            <Select placeholder='Select option' 
                            size='sm'
                            focusBorderColor={'redyel.600'}
                            borderColor={'redyel.400'}
                            color={'redyel.900'}
                            _placeholder={{ opacity: 0.3, color: 'redyel.800' }}
                            _hover={{
                                borderColor: 'redyel.500',
                            }}
                            borderRadius={'4'}
                            value={audience.gender} 
                            onChange={handleAudience} 
                            name={'gender'}>
                                <option value='Men'>Men</option>
                                <option value='Women'>Women</option>
                            </Select>
                        </FormControl>
                        <FormControl>
                            <FormLabel 
                                fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                minW={'10vw'}
                                color={'redyel.900'}>
                            Metric *
                            </FormLabel>
                            <Input 
                            type={'number'} 
                            placeholder='numerical value only (ex. 20 for 20%)' 
                            focusBorderColor={'redyel.600'}
                            borderColor={'redyel.400'}
                            color={'redyel.900'}
                            _placeholder={{ opacity: 0.3, color: 'redyel.800' }}
                            _hover={{
                                borderColor: 'redyel.500',
                            }}
                            borderRadius={'4'}
                            size='sm' 
                            value={audience.genderStat} 
                            onChange={handleAudience} 
                            name={'genderStat'}/>
                        </FormControl>
                    </HStack>
                    <HStack spacing={'3'}>
                        <FormControl>
                            <FormLabel 
                                fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                minW={'10vw'}
                                color={'redyel.900'}>
                            Age Range *
                            </FormLabel>
                            <Select placeholder='Select option'
                            size='sm'
                            focusBorderColor={'redyel.600'}
                            borderColor={'redyel.400'}
                            color={'redyel.900'}
                            _placeholder={{ opacity: 0.3, color: 'redyel.800' }}
                            _hover={{
                                borderColor: 'redyel.500',
                            }}
                            borderRadius={'4'}
                            value={audience.ageRange} 
                            onChange={handleAudience} 
                            name={'ageRange'}>
                                <option value='13-17'>13-17</option>
                                <option value='18-24'>18-24</option>
                                <option value='25-34'>25-34</option>
                                <option value='35-44'>35-44</option>
                                <option value='45-54'>45-54</option>
                                <option value='55-64'>55-64</option>
                                <option value='65+'>65+</option>
                            </Select>
                        </FormControl>
                        <FormControl>
                            <FormLabel 
                                fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                minW={'10vw'}
                                color={'redyel.900'}>
                            Metric *
                            </FormLabel>
                            <Input 
                            type={'number'} 
                            placeholder='numerical value only' 
                            focusBorderColor={'redyel.600'}
                            borderColor={'redyel.400'}
                            color={'redyel.900'}
                            _placeholder={{ opacity: 0.3, color: 'redyel.800' }}
                            _hover={{
                                borderColor: 'redyel.500',
                            }}
                            borderRadius={'4'}
                            size='sm' 
                            value={audience.ageRangeStat} 
                            onChange={handleAudience} 
                            name={'ageRangeStat'}/>
                        </FormControl>
                    </HStack>
                    <HStack spacing={'3'}>
                        <FormControl>
                            <FormLabel 
                                fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                minW={'10vw'}
                                color={'redyel.900'}>
                            Country *
                            </FormLabel>
                            <Input 
                            value={audience.country} 
                            focusBorderColor={'redyel.600'}
                            borderColor={'redyel.400'}
                            color={'redyel.900'}
                            _placeholder={{ opacity: 0.3, color: 'redyel.800' }}
                            _hover={{
                                borderColor: 'redyel.500',
                            }}
                            borderRadius={'4'}
                            size='sm' 
                            onChange={handleAudience} 
                            name={'country'} />
                        </FormControl>
                        <FormControl>
                            <FormLabel 
                                fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                minW={'10vw'}
                                color={'redyel.900'}>
                            Metric *
                            </FormLabel>
                            <Input 
                            type={'number'} 
                            placeholder='numerical value only' 
                            focusBorderColor={'redyel.600'}
                            borderColor={'redyel.400'}
                            color={'redyel.900'}
                            _placeholder={{ opacity: 0.3, color: 'redyel.800' }}
                            _hover={{
                                borderColor: 'redyel.500',
                            }}
                            borderRadius={'4'}
                            size='sm' 
                            value={audience.countryStat} 
                            onChange={handleAudience} 
                            name={'countryStat'}/>
                        </FormControl>
                    </HStack>

                    <Spacer />
                    <Divider borderColor={'redyel.400'}/>
                    <Spacer />
{/*Start of Services Section*/}   
                    <HStack spacing={'3'}>
                        <Text
                            fontSize={{ base: 'md', sm: 'md', md: 'lg' }}
                            as='b'
                            color={'redyel.700'}
                            fontFamily={'heading'}>
                        Services
                        </Text>
                        <Checkbox 
                            isChecked={includeRates}
                            onChange={onChangeChecked}
                            focusBorderColor={'redyel.600'}
                            borderColor={'redyel.400'}
                            color={'redyel.900'}
                            colorScheme={'white'}
                            iconColor={'redyel.800'}
                            _placeholder={{ opacity: 0.3, color: 'redyel.800' }}
                            _hover={{
                                borderColor: 'redyel.500',
                            }}
                            borderRadius={'4'}
                            size='md' 
                            fontFamily={'heading'}>
                                Include Rates
                        </Checkbox>
                    </HStack>
                    <HStack spacing={'3'}>
                        <FormControl>
                            <FormLabel 
                                fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                minW={'10vw'}
                                color={'redyel.900'}>
                            Service *
                            </FormLabel>
                            <Input 
                            focusBorderColor={'redyel.600'}
                            borderColor={'redyel.400'}
                            color={'redyel.900'}
                            _placeholder={{ opacity: 0.3, color: 'redyel.800' }}
                            _hover={{
                                borderColor: 'redyel.500',
                            }}
                            borderRadius={'4'}
                            size='sm' 
                            value={services.service1} 
                            onChange={handleServices} 
                            name={'service1'}/>
                        </FormControl>
                        <Fade in={includeRates}>
                            <HStack>
                                <FormControl>
                                    <FormLabel 
                                        fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                        minW={'10vw'}
                                        color={'redyel.900'}>
                                    Rate *
                                    </FormLabel>
                                    <Input 
                                    placeholder='ex. $500' 
                                    focusBorderColor={'redyel.600'}
                                    borderColor={'redyel.400'}
                                    color={'redyel.900'}
                                    _placeholder={{ opacity: 0.3, color: 'redyel.800' }}
                                    _hover={{
                                        borderColor: 'redyel.500',
                                    }}
                                    borderRadius={'4'}
                                    size='sm'  
                                    value={rates.rate1} 
                                    onChange={handleRates} 
                                    name={'rate1'}/>
                                </FormControl>
                            </HStack>                           
                        </Fade>
                    </HStack>
                    <HStack spacing={'3'}>
                        <FormControl>
                            <FormLabel 
                                fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                minW={'10vw'}
                                color={'redyel.900'}>
                            Service *
                            </FormLabel>
                            <Input focusBorderColor={'redyel.600'}
                            borderColor={'redyel.400'}
                            color={'redyel.900'}
                            _placeholder={{ opacity: 0.3, color: 'redyel.800' }}
                            _hover={{
                                borderColor: 'redyel.500',
                            }}
                            borderRadius={'4'}
                            size='sm' value={services.service2} onChange={handleServices} name={'service2'}/>
                        </FormControl>
                        <Fade in={includeRates}>
                            <HStack>
                                <FormControl>
                                    <FormLabel 
                                        fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                        minW={'10vw'}
                                        color={'redyel.900'}>
                                    Rate *
                                    </FormLabel>
                                    <Input focusBorderColor={'redyel.600'}
                                    borderColor={'redyel.400'}
                                    color={'redyel.900'}
                                    _placeholder={{ opacity: 0.3, color: 'redyel.800' }}
                                    _hover={{
                                        borderColor: 'redyel.500',
                                    }}
                                    borderRadius={'4'}
                                    size='sm' placeholder='ex. $500' value={rates.rate2} onChange={handleRates} name={'rate2'}/>
                                </FormControl>
                            </HStack>
                        </Fade>
                    </HStack>
                    <HStack spacing={'3'}>
                        <FormControl>
                            <FormLabel 
                                fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                minW={'10vw'}
                                color={'redyel.900'}>
                            Service *
                            </FormLabel>
                            <Input focusBorderColor={'redyel.600'}
                            borderColor={'redyel.400'}
                            color={'redyel.900'}
                            _placeholder={{ opacity: 0.3, color: 'redyel.800' }}
                            _hover={{
                                borderColor: 'redyel.500',
                            }}
                            borderRadius={'4'}
                            size='sm'  value={services.service3} onChange={handleServices} name={'service3'}/>
                        </FormControl>
                        <Fade in={includeRates}>
                            <HStack>
                                <FormControl>
                                    <FormLabel 
                                        fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                        minW={'10vw'}
                                        color={'redyel.900'}>
                                    Rate *
                                    </FormLabel>
                                    <Input focusBorderColor={'redyel.600'}
                                    borderColor={'redyel.400'}
                                    color={'redyel.900'}
                                    _placeholder={{ opacity: 0.3, color: 'redyel.800' }}
                                    _hover={{
                                        borderColor: 'redyel.500',
                                    }}
                                    borderRadius={'4'}
                                    size='sm' placeholder='ex. $500' value={rates.rate3} onChange={handleRates} name={'rate3'}/>
                                </FormControl>
                            </HStack>
                        </Fade>
                    </HStack>
                    <HStack spacing={'3'}>
                        <FormControl>
                            <FormLabel 
                                fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                minW={'10vw'}
                                color={'redyel.900'}>
                            Service
                            </FormLabel>
                            <Input focusBorderColor={'redyel.600'}
                            borderColor={'redyel.400'}
                            color={'redyel.900'}
                            _placeholder={{ opacity: 0.3, color: 'redyel.800' }}
                            _hover={{
                                borderColor: 'redyel.500',
                            }}
                            borderRadius={'4'}
                            size='sm' value={services.service4} onChange={handleServices} name={'service4'}/>
                        </FormControl>
                        <Fade in={includeRates}>
                            <HStack>
                                <FormControl>
                                    <FormLabel 
                                        fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                        minW={'10vw'}
                                        color={'redyel.900'}>
                                    Rate
                                    </FormLabel>
                                    <Input placeholder='ex. $500' focusBorderColor={'redyel.600'}
                                    borderColor={'redyel.400'}
                                    color={'redyel.900'}
                                    _placeholder={{ opacity: 0.3, color: 'redyel.800' }}
                                    _hover={{
                                        borderColor: 'redyel.500',
                                    }}
                                    borderRadius={'4'}
                                    size='sm' value={rates.rate4} onChange={handleRates} name={'rate4'}/>
                                </FormControl>
                            </HStack>
                        </Fade>
                    </HStack>
                    <HStack spacing={'3'}>
                        <FormControl>
                            <FormLabel 
                                fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                minW={'10vw'}
                                color={'redyel.900'}>
                            Service
                            </FormLabel>
                            <Input focusBorderColor={'redyel.600'}
                            borderColor={'redyel.400'}
                            color={'redyel.900'}
                            _placeholder={{ opacity: 0.3, color: 'redyel.800' }}
                            _hover={{
                                borderColor: 'redyel.500',
                            }}
                            borderRadius={'4'}
                            size='sm' value={services.service5} onChange={handleServices} name={'service5'}/>
                        </FormControl>
                        <Fade in={includeRates}>
                            <HStack>
                                <FormControl>
                                    <FormLabel 
                                        fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                        minW={'10vw'}
                                        color={'redyel.900'}>
                                    Rate
                                    </FormLabel>
                                    <Input placeholder='ex. $500' focusBorderColor={'redyel.600'}
                                    borderColor={'redyel.400'}
                                    color={'redyel.900'}
                                    _placeholder={{ opacity: 0.3, color: 'redyel.800' }}
                                    _hover={{
                                        borderColor: 'redyel.500',
                                    }}
                                    borderRadius={'4'}
                                    size='sm' value={rates.rate5} onChange={handleRates} name={'rate5'}/>
                                </FormControl>
                            </HStack>
                        </Fade>
                    </HStack>

                    <Spacer />
                    <Divider borderColor={'redyel.400'}/>
                    <Spacer />

{/*Start of Contact Section*/}
                    <HStack spacing={'3'}>
                        <Text
                            fontSize={{ base: 'md', sm: 'md', md: 'lg' }}
                            as='b'
                            color={'redyel.700'}
                            fontFamily={'heading'}>
                        Contact Information -- 2-3 methods
                        </Text>
                    </HStack>
                    <HStack spacing={'3'}>
                        <FormControl>
                            <FormLabel 
                                fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                minW={'10vw'}
                                color={'redyel.900'}>
                            Platform *
                            </FormLabel>
                            <Select placeholder='Select option' 
                            size='sm'
                            focusBorderColor={'redyel.600'}
                            borderColor={'redyel.400'}
                            color={'redyel.900'}
                            _placeholder={{ opacity: 0.3, color: 'redyel.800' }}
                            _hover={{
                                borderColor: 'redyel.500',
                            }}
                            borderRadius={'4'}
                            value={contact.contact1} 
                            onChange={handleContact} 
                            name={'contact1'}>
                                <option value='Tiktok'>TikTok</option>
                                <option value='Instagram'>Instagram</option>
                                <option value='Youtube'>YouTube</option>
                                <option value='Twitch'>Twitch</option>
                                <option value='Twitter'>Twitter</option>
                                <option value='Website'>Website</option>
                                <option value='Email'>Email</option>
                                <option value='All'>All Socials (if handle is same)</option>
                            </Select>
                        </FormControl>
                        <FormControl>
                            <FormLabel 
                                fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                minW={'10vw'}
                                color={'redyel.900'}>
                            Handle/Address *
                            </FormLabel>
                            <Input placeholder='for handles, please include the @' focusBorderColor={'redyel.600'}
                            borderColor={'redyel.400'}
                            color={'redyel.900'}
                            _placeholder={{ opacity: 0.3, color: 'redyel.800' }}
                            _hover={{
                                borderColor: 'redyel.500',
                            }}
                            borderRadius={'4'}
                            size='sm' value={contact.handle1} onChange={handleContact} name={'handle1'}/>
                        </FormControl>
                    </HStack>
                    <HStack spacing={'3'}>
                        <FormControl>
                            <FormLabel 
                                fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                minW={'10vw'}
                                color={'redyel.900'}>
                            Platform *
                            </FormLabel>
                            <Select placeholder='Select option' 
                            size='sm'
                            focusBorderColor={'redyel.600'}
                            borderColor={'redyel.400'}
                            color={'redyel.900'}
                            _placeholder={{ opacity: 0.3, color: 'redyel.800' }}
                            _hover={{
                                borderColor: 'redyel.500',
                            }}
                            borderRadius={'4'}
                            value={contact.contact2}
                            onChange={handleContact}
                            name={'contact2'}>
                                <option value='Tiktok'>TikTok</option>
                                <option value='Instagram'>Instagram</option>
                                <option value='Youtube'>YouTube</option>
                                <option value='Twitch'>Twitch</option>
                                <option value='Twitter'>Twitter</option>
                                <option value='Website'>Website</option>
                                <option value='Email'>Email</option>
                                <option value='All'>All Socials (if handle is same)</option>
                            </Select>
                        </FormControl>
                        <FormControl>
                            <FormLabel 
                                fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                minW={'10vw'}
                                color={'redyel.900'}>
                            Handle/Address *
                            </FormLabel>
                            <Input placeholder='for handles, please include the @' focusBorderColor={'redyel.600'}
                            borderColor={'redyel.400'}
                            color={'redyel.900'}
                            _placeholder={{ opacity: 0.3, color: 'redyel.800' }}
                            _hover={{
                                borderColor: 'redyel.500',
                            }}
                            borderRadius={'4'}
                            size='sm' value={contact.handle2} onChange={handleContact} name={'handle2'}/>
                        </FormControl>
                    </HStack>
                    <HStack spacing={'3'}>
                        <FormControl>
                            <FormLabel 
                                fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                minW={'10vw'}
                                color={'redyel.900'}>
                            Platform
                            </FormLabel>
                            <Select placeholder='Select option'
                            size='sm'
                            focusBorderColor={'redyel.600'}
                            borderColor={'redyel.400'}
                            color={'redyel.900'}
                            _placeholder={{ opacity: 0.3, color: 'redyel.800' }}
                            _hover={{
                                borderColor: 'redyel.500',
                            }}
                            borderRadius={'4'} 
                            value={contact.contact3} 
                            onChange={handleContact} 
                            name={'contact3'}>
                                <option value='Tiktok'>TikTok</option>
                                <option value='Instagram'>Instagram</option>
                                <option value='Youtube'>YouTube</option>
                                <option value='Twitch'>Twitch</option>
                                <option value='Twitter'>Twitter</option>
                                <option value='Website'>Website</option>
                                <option value='Email'>Email</option>
                                <option value='All'>All Socials (if handle is same)</option>
                            </Select>
                        </FormControl>
                        <FormControl>
                            <FormLabel 
                                fontSize={{ base: 'sm', sm: 'sm', md: 'md' }}
                                minW={'10vw'}
                                color={'redyel.900'}>
                            Handle/Address
                            </FormLabel>
                            <Input placeholder='for handles, please include the @' focusBorderColor={'redyel.600'}
                            borderColor={'redyel.400'}
                            color={'redyel.900'}
                            _placeholder={{ opacity: 0.3, color: 'redyel.800' }}
                            _hover={{
                                borderColor: 'redyel.500',
                            }}
                            borderRadius={'4'}
                            size='sm' value={contact.handle3} onChange={handleContact} name={'handle3'} />
                        </FormControl>
                    </HStack>
                    <Spacer />
                    <Spacer />
                
                    <Button 
                        bg={'redyel.600'}
                        color={'redyel.300'}
                        minW={'30vw'}
                        maxW={'70vw'}
                        alignSelf={'center'}s
                        _hover={{
                            bg: 'redyel.500',
                        }}
                        onClick={handleKitGenerate}
                        isDisabled={generate}>
                            {generate ? 'Rendered kit will update automatically': 'Generate Media Kit'}
                    </Button>

{/*Render Kit Area*/}
                { generate && 
                    <Fade bottom delay={10000} duration={2000}>
                        <Box p={'3vh'} justifyContent={'center'} display={'flex'}>
                            <div id={'printReference'} w={'51vw'} h={'66vw'}>
                                <MinimalistKit 
                                    name={name}
                                    subheader={subheader}
                                    bio={bio}
                                    profile={profile}
                                    followers={followers}
                                    stats={stats}
                                    audience={audience} 
                                    services={services}
                                    includeRates={includeRates} 
                                    rates={rates}
                                    contact={contact}
                                    addlPhoto1={file1}
                                    addlPhoto2={file2}/>
                            </div>
                        </Box>
                    </Fade> }
{/*Generate PDF Button*/}  
                { generate &&
                    <Fade bottom delay={10000} duration={2000}>
                        <Button 
                            bg={'redyel.600'}
                            color={'redyel.300'}
                            minW={'30vw'}
                            maxW={'70vw'}
                            alignSelf={'center'}s
                            _hover={{
                                bg: 'redyel.500',
                            }}
                            onClick={handleDownloadJpg}>
                                Download as JPEG
                        </Button>
                    </Fade> }
                </Stack>
            </Box>
    );
};
